import classNames from 'classnames';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const Dot = ({ value, max }) => {
    return (
        <div className={styles.root}>
            <div className={classNames(styles.value, styles[`dot-${max}-${value}`])}>
                <Title size='sm' color='white'>
                    {value}
                </Title>
            </div>
        </div>
    );
};

export default Dot;
